module.exports = __webpack_public_path__ + "img/requirement.7dfdb64.png";